import { apiPost } from '~/_shared/utils/api/api.helpers';
import type { MapTemplates } from './mapTemplates.helpers';

type RecordTemplateUsageRequest = Readonly<{
  template: MapTemplates;
  mapId: number;
}>;

type RecordTemplateUsageResponse = Readonly<{
  code?: 'SUCCESS';
}>;

export const recordTemplateUsage = (clientId: number, request: RecordTemplateUsageRequest): Promise<RecordTemplateUsageResponse> => {
  const requestUrl = `/api/clients/${clientId}/map-templates/usage`;

  return apiPost(requestUrl, {
    template_id: request.template,
    map_id: request.mapId,
  });
};
